import { createSelector } from 'reselect';
import { RootState } from '../state';

export const selectBillingState = (state: RootState) => state?.billing;

export const selectSyncSubscriptionStatus = createSelector(
  selectBillingState,
  (state) => state?.sync,
)
